const BillingClientDirectory = () => {
  return (
    <div>
      <p>Annuaire société de facturation page</p>
    </div>
  );
};

export default BillingClientDirectory;
